module.exports = __webpack_public_path__ + "img/f5dde83c4f8d3d2633710b9210120dce.svg";